// Europass-specific geometry. The Europass page uses 20px margins (vs 40px for
// the other variants) and insets each section by paddingHorizontal 20 + a 40px
// right margin. These constants centralise that so sections stay aligned.

import { BorderStyle } from "docx";
import { para, run } from "../shared/wordHelpers";
import { EUROPASS_RULE } from "../shared/wordTheme";
import { A4, pxToTwips } from "../shared/wordUnits";

export const EU_MARGIN = pxToTwips( 20 );
export const EU_USABLE = A4.width - EU_MARGIN * 2;

// Section content inset (paddingHorizontal 20 left, +40 right margin = 60 right).
export const EU_INDENT = { left: pxToTwips( 20 ), right: pxToTwips( 60 ) };
export const EU_TABLE_INDENT = pxToTwips( 20 );
export const EU_TABLE_WIDTH = EU_USABLE - pxToTwips( 20 ) - pxToTwips( 60 );

export function euPara( children, options = {} ) {
    return para( children, { indent: EU_INDENT, ...options } );
}

// Grey separator rule spanning the section content width.
export function euRule() {
    return para( [], {
        border: { bottom: { style: BorderStyle.SINGLE, size: 6, color: EUROPASS_RULE } },
        spacing: { before: pxToTwips( 1 ), after: pxToTwips( 5 ) },
        indent: EU_INDENT,
    } );
}

// "• text" bullet inset within the section, hanging so wrapped lines align.
export function euBullet( text, { pt = 8, font, color } = {} ) {
    return para(
        [ run( "•", { pt, font, color } ), run( `  ${ text }`, { pt, font, color } ) ],
        {
            indent: { left: EU_INDENT.left + pxToTwips( 12 ), right: EU_INDENT.right, hanging: pxToTwips( 12 ) },
            spacing: { after: 0 },
        }
    );
}
